import { render } from "./gradientEditor.vue?vue&type=template&id=20428b3c&scoped=true&ts=true"
import script from "./gradientEditor.vue?vue&type=script&lang=ts"
export * from "./gradientEditor.vue?vue&type=script&lang=ts"

import "./gradientEditor.vue?vue&type=style&index=0&id=20428b3c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20428b3c"]])

export default __exports__